import ModalAdapter from './ModalAdapter';

export default ModalAdapter;
